export default __webpack_public_path__ + "static/media/card_a.bff2a607.png";